import "katex/dist/katex.min.css";

import Latex from "react-latex-next";
import type { FC } from "react";

import { AbilityScore, AnswerExercise } from "components";

import { useAppSelector } from "store/hooks";
import { getAbilityScore } from "store/slices/exercise";
import type { IAssignmentResult, IOption } from "store/slices/exercise";

import { ABCDOptionText } from "utils/formatTextForAnalysis";
import { isSelfEvaluationForEveryAssignment } from "utils/valueTranslators";
import { getAbilityScoreOptions } from "utils/changeAbilityScore";

import type { UserAssignmentForExerciseFragment } from "api/generated";
import { AssignmentPrompt } from "components/AssignmentPrompt";

interface Props {
  assignmentResult: IAssignmentResult<IOption | string>;
  assignmentDetail: UserAssignmentForExerciseFragment;
  toggleModals: (showQuestionAnalysisIndex: number | null) => void;
}

const ABCD: FC<Props> = ({ assignmentDetail, assignmentResult, toggleModals }) => {
  const { assignment } = assignmentDetail;
  if (assignment === undefined || assignment === null) return null;

  const isSelfEvaluation = assignment.scoring?.scoringMethod.scoringMethod === "sebeopravení";
  const abilityScore = useAppSelector(getAbilityScore(assignmentDetail.id));

  const getAbilityScoreOnIndex = (index: number) => {
    if (abilityScore === undefined || typeof abilityScore === "number") return 0;

    return abilityScore[index];
  };

  return (
    <>
      <AssignmentPrompt assignment={assignment?.assignment} />

      {assignment.assignment?.questions.map((question, qIndex) => {
        const selfEvalOptions = getAbilityScoreOptions(isSelfEvaluation, assignmentResult.answersVariants?.[qIndex]);

        return (
          <>
            <Latex>{question.heading ?? ""}</Latex>

            <AnswerExercise
              subject={assignmentDetail.subject?.appName}
              key={`answer-${qIndex}`}
              index={qIndex}
              assignment={assignment}
              type={assignmentResult.answersVariants?.[qIndex]}
              toggleModals={toggleModals}
              userAssignmentId={assignmentDetail.id}
              addIcon={true}
              tipDisabled={true}
            >
              {ABCDOptionText(assignmentResult.answers?.[qIndex])}
            </AnswerExercise>

            {isSelfEvaluationForEveryAssignment(assignment) &&
            question.showAbilityScore === true &&
            selfEvalOptions !== null ? (
              <>
                <hr className={"my-25px"} />
                <div className="mw-sm">
                  <AbilityScore
                    isSelfEvaluated={isSelfEvaluation}
                    options={selfEvalOptions}
                    selectedValue={getAbilityScoreOnIndex(qIndex)}
                    onValueSelect={() => {}}
                    index={qIndex}
                    key={qIndex}
                  />
                </div>
              </>
            ) : null}
          </>
        );
      })}
    </>
  );
};

export default ABCD;
